import HOME_TYPES from '../types/homeTypes';

const initialState = {
  loading: false,
  submitting: false,
  deleting: false,
  scheduleData: null,
  messages: [],
  notifications: [],
  unreadCount: 0,
  completionStatus: [],
  currentPage: 1,
  isLastPage: true,
  notificationToken: null,
  error: null,
};

export default function homeReducer(state = initialState, action) {
  switch (action.type) {
    case HOME_TYPES.FETCH_SCHEDULE_DATA_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case HOME_TYPES.FETCH_SCHEDULE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        scheduleData: action.payload.data,
      };

    case HOME_TYPES.FETCH_SCHEDULE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case HOME_TYPES.INVITE_USER_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case HOME_TYPES.INVITE_USER_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case HOME_TYPES.INVITE_USER_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case HOME_TYPES.SUBMIT_CONTACT_FORM_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case HOME_TYPES.SUBMIT_CONTACT_FORM_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case HOME_TYPES.SUBMIT_CONTACT_FORM_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case HOME_TYPES.FETCH_MESSAGES_BEGIN:
      return {
        ...state,
        loading: true,
        currentPage: action.payload.page,
        error: null,
      };

    case HOME_TYPES.FETCH_MESSAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        messages: action.payload.data?.messages ?? [],
        isLastPage: action.payload.data.isLastPage,
      };

    case HOME_TYPES.FETCH_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case HOME_TYPES.UPDATE_NOTIFICATION_TOKEN_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case HOME_TYPES.UPDATE_NOTIFICATION_TOKEN_SUCCESS:
      return {
        ...state,
        submitting: false,
        notificationToken: action.payload.data.token,
      };

    case HOME_TYPES.UPDATE_NOTIFICATION_TOKEN_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };
    case HOME_TYPES.FETCH_NOTIFICATIONS_BEGIN:
      return {
        ...state,
        loading: true,
        currentPage: action.payload.page,
        error: null,
      };

    case HOME_TYPES.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload.data.notifications,
        isLastPage: action.payload.data.isLastPage,
      };

    case HOME_TYPES.MARK_NOTIFICATION_READ_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case HOME_TYPES.MARK_NOTIFICATION_READ_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case HOME_TYPES.MARK_NOTIFICATION_READ_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case HOME_TYPES.DELETE_NOTIFICATION_BEGIN:
      return {
        ...state,
        deleting: true,
        error: null,
      };

    case HOME_TYPES.DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        deleting: false,
      };

    case HOME_TYPES.DELETE_NOTIFICATION_FAILURE:
      return {
        ...state,
        deleting: false,
        error: action.payload.error,
      };

    case HOME_TYPES.FETCH_UNREAD_COUNT_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case HOME_TYPES.FETCH_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        unreadCount: action.payload.data,
      };

    case HOME_TYPES.FETCH_UNREAD_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case HOME_TYPES.FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case HOME_TYPES.FETCH_COMPLETION_SUCCESS:
      return {
        ...state,
        completionStatus: action.payload.data,
      };

    default:
      return state;
  }
}
